<script>
  export default {
    name: 'content-header',
    props: {
      headerLevel: {
        type: Number,
        required: true
      },
      title: null
    },
    render (createElement) {
      return createElement(
        'h' + this.headerLevel, // header tag name
        {
          domProps: {
            id: this.title.replace(/ /g, ''),
            innerHTML: this.title // array of children
          }
        }
      )
    }
  }
</script>



// WEBPACK FOOTER //
// ContentHeaderComponent.vue?045b09a8